import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Box, Button } from '@mui/material';
import organizersData from './organizersData';
import { Container, Grid } from '@mui/material';
import { useDevice } from 'components/DeviceContext.js';

const OrganizerDetail = () => {
	const { name } = useParams();
	const navigate = useNavigate();
	const { isMobile, isLaptop, isDesktop } = useDevice();
	const organizer = organizersData.find(org => org.name === name);

	return (
		<Container>
			<Grid style={{ minHeight: "100vh", alignContent: 'center', alignItems: 'center', marginTop: '5em', padding: isMobile  ? '2em 0' : '5em' }}>
				<Box display="flex" flexDirection="column" alignItems="center" padding="2em" textAlign="center" style={{ minHeight: "80vh", display: 'flex', boxShadow: '0px 0.1px 200px rgba(255, 255, 255, 10.60)', backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: '5em' }}>
					<Grid style={{ display: isMobile ? '' : 'flex', alignItems: 'center' }}>
						<img
							src={organizer?.imgOrganizadores}
							alt='IMG'
							style={{ width: isMobile ? '100%' : isLaptop ? '400px' : '300px', height: isMobile ? '290px' : isLaptop ? '350px' : '290px', objectFit: 'cover', padding: 0, borderRadius: isDesktop ? 0 : '50px' }}
						/>
						<Grid>

							<Typography variant="h4" gutterBottom style={{marginLeft: isMobile ? 0 :  '2em'}}>{organizer?.name}

								<Typography style={{ borderBottom: `6px solid ${organizer?.bgColor}`, width: '100%', textAlign: 'center' }}></Typography>
							<Typography variant="h5" color="textSecondary">{organizer?.title}</Typography>
							</Typography>
						</Grid>

					</Grid>
					<Typography variant="body1" style={{ marginTop: '1.5em', fontSize: isMobile  ? '1em' : isLaptop ? '1.4em' : '1.2em', padding: isLaptop ? '2em' : '1em' }}>
						{organizer?.description}
					</Typography>
					<Button
						variant="outlined"
						color="primary"
						onClick={() => navigate(-1)}
						style={{ marginTop: '2em' }}
					>
						Voltar
					</Button>
				</Box>
			</Grid>
		</Container>
	);
};

export default OrganizerDetail;
